import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'list',
    name: 'section.param-assessments.list',
    component: () => import('@/views/control-panel/projects/project/sections/section/paramAssessments/List.vue'),
  }
]

export default routes
